import React from "react";
import moment from "moment";
import { setStatus } from "../actions/messageActions";
import { useDispatch } from "react-redux";
const DashboardDetails = ({
  indexOfFirstArticle,
  indexOfLastArticle,
  requests,
  setRequests,
}) => {
  const dispatch = useDispatch();
  const handleChangeStatus = async (e, id, status) => {
    requests.forEach((data, idx) => {
      const { _id } = data;
      if (_id === id) {
        requests[idx].status = e.target.value;
        setRequests([...requests]);
      }
    });
    dispatch({
      type: "CHANGE_DASHBOARD_STATUS",
      payload: { prev: status.prevStatus, updated: e.target.value },
    });
    const data = await setStatus({ id, status: e.target.value });

    // data.param && setError(data);
  };
  return (
    <>
      {requests.slice(indexOfFirstArticle, indexOfLastArticle).map((data) => {
        const { _id, message, fullName, email, status, createdAt } = data;
        return (
          <tr className="each-request-list" key={_id}>
            <td>{message}</td>
            <td>{fullName}</td>
            <td className="email-container">{email}</td>
            <td>
              <span className={`indicator ${status}`} />
              {!status ? "NO" : status}
            </td>
            <td>{moment(createdAt).format("L")}</td>
            <td className="action-container">
              <select
                name="actions"
                id="actions"
                onChange={(e) =>
                  handleChangeStatus(e, _id, { prevStatus: status })
                }
              >
                <option>Actions</option>
                <option value="Read">Read</option>
                <option value="Completed">Completed</option>
                <option value="Pending">Pending</option>
                <option value="Rejected">Reject</option>
              </select>
            </td>
          </tr>
        );
      })}
    </>
  );
};

export default DashboardDetails;
